export enum AppName {
  IEA = "ieaApp",
  ARENA_EQ = 'arenaEqApp'
}